<script setup lang="ts">
import LottieAnimation from '@/components/Common/LottieAnimation.vue';
import LoadingActiveOutreachData from '@/assets/json/loading-active-outreach-cards.json';

interface Props {
  width?: string;
  height?: string;
  speed?: number;
  loop?: boolean;
}

withDefaults(defineProps<Props>(), {
  width: '100%',
  height: '200px',
  speed: 1,
  loop: true,
});

const emit = defineEmits<{
  (e: 'animation:complete'): void;
  (e: 'animation:loaded'): void;
}>();

const handleComplete = () => {
  emit('animation:complete');
};

const handleLoaded = () => {
  emit('animation:loaded');
};
</script>

<template>
  <LottieAnimation
    :animation-data="LoadingActiveOutreachData"
    :loop="loop"
    :autoplay="true"
    :width="width"
    :height="height"
    :speed="speed"
    @animation:complete="handleComplete"
    @animation:loaded="handleLoaded"
  />
</template>
